import { defineMessages } from "@/i18n";
import en from "./en";

export const framesConversationMessages = defineMessages(
  "frames-conversation",
  en,
);
